export const es = {
  // Common
  loading: 'Cargando...',
  signOut: 'Cerrar Sesión',
  welcome: 'Bienvenido de vuelta',
  cancel: 'Cancelar',
  
  // Authentication
  signIn: 'Iniciar Sesión',
  signInTo: 'Iniciar sesión en Simple Handshake',
  timeTrackingMadeSimple: 'Control de tiempo simplificado',
  emailAddress: 'Dirección de correo electrónico',
  password: 'Contraseña',
  signingIn: 'Iniciando sesión...',
  dontHaveAccount: '¿No tienes una cuenta?',
  registerHere: 'Regístrate aquí',
  alreadyHaveAccount: '¿Ya tienes una cuenta?',
  signInHere: 'Inicia sesión aquí',
  
  // Passwordless Authentication
  phoneNumber: 'Número de teléfono',
  enterPhone: 'Ingresa tu número de teléfono',
  verificationCode: 'Código de verificación',
  verifyCode: 'Verificar código',
  enterVerificationCode: 'Ingresa el código de verificación',
  sendCode: 'Enviar código',
  sendingCode: 'Enviando código...',
  verifying: 'Verificando...',
  resendCode: 'Reenviar código',
  backToLogin: 'Volver al inicio de sesión',
  backToRegister: 'Volver al registro',
  codeSentTo: 'Código enviado a',
  weWillSendCodeToEmail: 'Te enviaremos un código de verificación por correo electrónico',
  weWillSendCodeToPhone: 'Te enviaremos un código de verificación por SMS',
  provideEmailOrPhone: 'Proporciona tu correo electrónico o número de teléfono.',
  weWillSendVerificationCode: 'Te enviaremos un código de verificación.',
  optional: 'opcional',
  usePhoneInstead: '¿Usar número de teléfono?',
  useEmailInstead: '¿Usar correo electrónico?',
  forgotPassword: '¿Olvidaste tu contraseña?',
  resetHere: 'Restablecer aquí',
  primaryLoginMethod: 'Método principal de inicio de sesión',
  emailForMarketingAndBackup: 'Para marketing y respaldo en caso de pérdida del número',
  howItWorks: 'Cómo funciona',
  smsPrimaryMethod: 'SMS como método principal de autenticación',
  emailForBackup: 'Email para respaldo y marketing',
  secureOTPVerification: 'Verificación segura con código OTP',
  requestSubmitted: 'Solicitud enviada',
  enterIdentifierForReset: 'Ingresa tu email o teléfono para restablecer tu contraseña',
  adminWillContactYou: 'Un administrador se pondrá en contacto contigo',
  enterIdentifierForPasswordReset: 'Ingresa tu email o teléfono para solicitar restablecimiento de contraseña',
  importantNotice: 'Aviso importante',
  passwordResetRequiresAdmin: 'El restablecimiento de contraseña requiere validación del administrador',
  submitting: 'Enviando...',
  submitRequest: 'Enviar solicitud',
  rememberPassword: '¿Recordaste tu contraseña?',
  adminWillReviewRequest: 'Un administrador revisará tu solicitud',
  youWillBeContacted: 'Te contactaremos pronto',
  submitAnotherRequest: 'Enviar otra solicitud',
  
  // Registration
  createAccount: 'Crear cuenta',
  createYourAccount: 'Crea tu cuenta',
  joinSimpleHandshake: 'Únete a Simple Handshake hoy',
  fullName: 'Nombre completo',
  enterFullName: 'Ingresa tu nombre completo',
  enterEmail: 'Ingresa tu correo electrónico',
  createPassword: 'Crea una contraseña',
  iAmA: 'Soy un...',
  client: 'Cliente (Necesito que los proveedores registren entrada)',
  provider: 'Proveedor (Registro entrada en sitios de clientes)',
  creatingAccount: 'Creando cuenta...',
  
  // Client Dashboard
  clientDashboard: 'Panel de Cliente',
  yourQRCode: 'Tu Código QR',
  qrCodeWillBeDisplayed: 'El código QR se mostrará aquí',
  showQRCodeToProviders: 'Muestra este código QR a los proveedores para el registro de entrada',
  recentCheckIns: 'Registros de Entrada Recientes',
  noRecentCheckIns: 'No hay registros de entrada recientes',
  yourInformation: 'Tu Información',
  name: 'Nombre',
  email: 'Correo electrónico',
  status: 'Estado',
  approved: 'Aprobado',
  pending: 'Pendiente',
  quickActions: 'Acciones Rápidas',
  generateNewQRCode: 'Generar Nuevo Código QR',
  viewCheckInHistory: 'Ver Historial de Entradas',
  updateProfile: 'Actualizar Perfil',
  
  // Provider Dashboard
  providerDashboard: 'Panel de Proveedor',
  checkInCheckOut: 'Registro de Entrada/Salida',
  notCurrentlyCheckedIn: 'No registrado actualmente',
  scanClientQRCode: 'Escanee el código QR del cliente para registrarse',
  scanQRCode: 'Escanear Código QR',
  todaysSchedule: 'Horario de Hoy',
  noScheduledJobs: 'No hay trabajos programados para hoy',
  recentActivity: 'Actividad Reciente',
  noRecentActivity: 'No hay actividad reciente',
  viewFullSchedule: 'Ver Horario Completo',
  viewTimeReports: 'Ver Reportes de Tiempo',
  thisWeeksTime: 'Tiempo de Esta Semana',
  totalHours: 'Horas Totales',
  jobsCompleted: 'Trabajos Completados',
  jobsScheduled: 'Trabajos Programados',
  averageHoursPerDay: 'Promedio por Día',
  
  // QR Scanner
  scanning: 'Escaneando',
  startScanning: 'Iniciar Escaneo',
  pointCameraAtQRCode: 'Apunta la cámara al código QR del cliente',
  enterManually: 'Ingresar Manualmente',
  enterQRCodeManually: 'Ingresa el código QR manualmente',
  
  // Enhanced Provider Features
  activeSession: 'Sesión Activa',
  sessionActive: 'Sesión activa',
  sessionDuration: 'Duración de la sesión',
  endSession: 'Finalizar Sesión',
  confirmCheckOut: 'Confirmar Salida',
  checkOutConfirmation: 'Confirmación de Salida',
  timeWorked: 'Tiempo Trabajado',
  expectedTime: 'Tiempo Esperado',
  timeVariation: 'Variación de Tiempo',
  withinExpectedRange: 'Dentro del rango esperado',
  aboveExpectedTime: 'Por encima del tiempo esperado',
  belowExpectedTime: 'Por debajo del tiempo esperado',
  
  // Job Management
  scheduledJobs: 'Trabajos Programados',
  flexibleJobs: 'Trabajos Flexibles',
  adHocJobs: 'Trabajos Ad-hoc',
  jobDetails: 'Detalles del Trabajo',
  jobType: 'Tipo de Trabajo',
  startTime: 'Hora de Inicio',
  endTime: 'Hora de Fin',
  duration: 'Duración',
  jobStatus: 'Estado del Trabajo',
  active: 'Activo',
  completed: 'Completado',
  cancelled: 'Cancelado',
  
  // Schedule and Calendar
  today: 'Hoy',
  tomorrow: 'Mañana',
  thisWeek: 'Esta Semana',
  nextWeek: 'Próxima Semana',
  noJobsToday: 'No hay trabajos para hoy',
  upcomingJobs: 'Próximos Trabajos',
  pastJobs: 'Trabajos Anteriores',
  schedule: 'Horario',
  calendar: 'Calendario',
  
  // Time Tracking
  timeTracking: 'Control de Tiempo',
  clockIn: 'Registrar Entrada',
  clockOut: 'Registrar Salida',
  breakTime: 'Tiempo de Descanso',
  totalWorkTime: 'Tiempo Total de Trabajo',
  weeklySummary: 'Resumen Semanal',
  monthlySummary: 'Resumen Mensual',
  
  // Notifications and Alerts
  newJobAssigned: 'Nuevo trabajo asignado',
  jobReminder: 'Recordatorio de trabajo',
  timeAlert: 'Alerta de tiempo',
  sessionTimeout: 'Tiempo de sesión agotado',
  
  // Admin Dashboard
  adminDashboard: 'Panel de Administrador',
  pendingApprovals: 'Aprobaciones Pendientes',
  noPendingApprovals: 'No hay aprobaciones pendientes',
  allUsersProcessed: 'Todos los usuarios han sido procesados',
  viewAllUsers: 'Ver Todos los Usuarios',
  systemStatistics: 'Estadísticas del Sistema',
  totalUsers: 'Usuarios Totales',
  activeJobs: 'Trabajos Activos',
  checkInsToday: 'Entradas Hoy',
  pendingIssues: 'Problemas Pendientes',
  createNewJob: 'Crear Nuevo Trabajo',
  manageUsers: 'Gestionar Usuarios',
  viewReports: 'Ver Reportes',
  systemSettings: 'Configuración del Sistema',
  recentSystemActivity: 'Actividad Reciente del Sistema',
  adminInformation: 'Información del Administrador',
  role: 'Rol',
  administrator: 'Administrador',
  systemHealth: 'Salud del Sistema',
  apiStatus: 'Estado de la API',
  online: 'En Línea',
  database: 'Base de Datos',
  connected: 'Conectado',
  authentication: 'Autenticación',
  
  // Status messages
  loadingSimpleHandshake: 'Cargando Simple Handshake...',
  
  // Phone validation messages
  validPhoneNumber: 'Número de teléfono válido',
  internationalNumber: 'Número internacional',
  localNumber: 'Número local',
  enterPhoneNumber: 'Ingresa tu número de teléfono',
  
  // Error messages
  error: 'Error',
  somethingWentWrong: 'Algo salió mal',
  tryAgain: 'Inténtalo de nuevo',
  networkError: 'Error de red',
  sessionStartError: 'Error al iniciar sesión',
  sessionStartFailed: 'Error al iniciar sesión',
  sessionStartedSuccessfully: 'Sesión iniciada exitosamente',
  errorStartingSession: 'Error al iniciar sesión',
  errorLoadingInfo: 'Error al cargar información',
  qrCodeInvalid: 'Código QR inválido',
  qrCodeExpired: 'Código QR expirado',
  clientNotFound: 'Cliente no encontrado',
  
  // Success messages
  success: 'Éxito',
  operationCompleted: 'Operación completada',
  
  // Time formats
  hours: 'h',
  minutes: 'm',
  
  // User types
  userType: {
    client: 'Cliente',
    provider: 'Proveedor',
    admin: 'Administrador'
  },
  
  // Check-in specific
  confirmCheckIn: 'Confirmar Check-in',
  checkInProvider: 'Check-in de Proveedor',
  readyToStartSession: '¿Estás listo para iniciar la sesión con este cliente?',
  startSession: 'Iniciar Sesión',
  starting: 'Iniciando...',
  elapsedTime: 'Tiempo transcurrido',
  remindClient: 'Recuerda pedirle al cliente su código QR cuando estés listo para finalizar la sesión',
  clientInformation: 'Información del Cliente',
  heroVideoPlaceholder: 'Video explicativo',
  backToHome: 'Volver al Inicio',
  whatsAppSupport: 'Soporte WhatsApp',
  whatsAppSupportMessage: 'Hola, necesito ayuda con el sistema de check-in.',
  register: 'Registrarse',
  newUser: '¿Eres nuevo?'
}; 